import { useInteractiveCallback } from '@/hook/useInteractiveCallback';
import { Reel } from '@/types/reel.type';
import { DataState } from '@/types/data.type';

import { useAppDispatch, useAppSelector } from '../store';

import {
    setReels,
    setReelName,
    REELS_REDUCER_NAME,
    setDataState,
} from './reels.slice';

// SELECTORS
export function useReels() {
    return useAppSelector((state) => state[REELS_REDUCER_NAME]);
}

export function useReelsData() {
    const reelsData = useAppSelector((state) => state.reels.data);

    return reelsData;
}

export function useReelsDataByCode(code: string) {
    const reelsData = useReelsData();

    return reelsData.find((reel) => reel.code === code);
}

export function useReelsDataState() {
    const reelsDataState = useAppSelector((state) => state.reels.dataState);

    return reelsDataState;
}

// DISPATCHERS
export function useSetReels() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reels: Reel[]) => {
        dispatch(setReels({ reels }));
    });
}

export function useSetReelName() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((reelCode: string, name: string) => {
        dispatch(
            setReelName({
                reelCode,
                name,
            }),
        );
    });
}

export function useSetReelsDataState() {
    const dispatch = useAppDispatch();

    return useInteractiveCallback((dataState: DataState) => {
        dispatch(setDataState({ dataState }));
    });
}
